import axios from 'axios';
import i18n from '@/i18n';
import {
  isLimiteApiExternaAxiosError,
  notifyLimiteApiExternaError,
} from '@/utils/limiteApiExterna';

// Configurar interceptor para adicionar o cabeçalho Accept-Language em todas as requisições
axios.interceptors.request.use(
  (config) => {
    // Adiciona o idioma atual do i18n ao cabeçalho da requisição
    config.headers['Accept-Language'] = i18n.locale;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isLimiteApiExternaAxiosError(error)) {
      notifyLimiteApiExternaError(error);
    }
    return Promise.reject(error);
  }
);

export default axios;

